<template>
  <!--
      作者 kmdshop
      时间：2020-06-09
      描述：会员-等级管理-编辑等级
  -->
  <div>
    <el-dialog title="编辑等级" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false" width="800px">
    <el-form size="small" :model="form" ref="form">
      <el-form-item label="等级名称" :label-width="formLabelWidth" prop="name" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="等级折扣" :label-width="formLabelWidth" prop="equity" :rules="[{required: true,message: '请输入等级折扣'}]">
        <el-input type="number" :precision="1" :step="1" :min="0" :max="100" placeholder="请输入等级折扣" v-model="form.equity">
            <template slot="append">%</template>
        </el-input>
      </el-form-item>
      <el-form-item label="等级编码" :label-width="formLabelWidth" prop="grade_code">
        <el-input v-model="form.grade_code" placeholder="请输入等级编码" maxlength="4"></el-input>
      </el-form-item>
      
       <el-form-item :label-width="formLabelWidth" label="购买权限">
        <el-radio-group v-model="form.can_buy">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- <el-form-item :label-width="formLabelWidth" label="是否能申请门店">
        <el-radio-group v-model="form.is_apply_store">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item> -->
       <el-form-item :label-width="formLabelWidth" label="渠道">
        <el-radio-group v-model="form.is_agent">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
       <el-form-item label="选择级别" :label-width="formLabelWidth" >
        <el-select v-model="form.level" >
          <el-option v-for="(item,index) in levelList" :key="index" :label="item.level" :value="item.level"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="购买升级金额" :label-width="formLabelWidth" prop="level_money" >
        <el-input type="number"  min="0" v-model="form.level_money" placeholder="购买升级金额">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>

      <el-form-item label="购买升级期限" :label-width="formLabelWidth" prop="expire_year" >
        <el-input type="number"  min="0" v-model="form.expire_year" placeholder="购买升级期限">
          <template slot="append">年</template>
        </el-input>
        <div>到期后会自动降级到上一级,设置为0则不会到期</div>
      </el-form-item>

      <el-form-item label="特权" prop="privilege" :label-width="formLabelWidth">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入特权"
            v-model="form.privilege">
          </el-input>
      </el-form-item>

      <el-form-item label="inon" prop="path" :label-width="formLabelWidth">
        <el-row>
          <el-button type="primary" @click="openUpload4">上传图片</el-button>
          <div v-if="path" class="img">
            <img :src="path" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>
      
      <el-form-item label="点击前背景图" prop="path_before" :label-width="formLabelWidth">
        <el-row>
          <el-button type="primary" @click="openUpload">上传点击前图片</el-button>
          <div v-if="path_before" class="img">
            <img :src="path_before" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="点击后背景图" prop="path_after" :label-width="formLabelWidth">
        <el-row>
          <el-button type="primary" @click="openUpload3">上传点击后图片</el-button>
          <div v-if="path_after" class="img">
            <img :src="path_after" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>

      <el-form-item label="详情图" prop="detail" :label-width="formLabelWidth">
        <el-row>
          <el-button type="primary" @click="openUpload2">上传图片</el-button>
          <div v-if="detail" class="img">
            <img :src="detail" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>

      <el-form-item label="备注" prop="content" :label-width="formLabelWidth">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入内容"
            v-model="content">
          </el-input>
      </el-form-item>

      

      <el-form-item label="升级条件" :label-width="formLabelWidth" v-if="form.is_default==0">
        <div class="d-s-c mt16">
          <el-checkbox v-model="form.is_coexist">是否同时满足</el-checkbox>
          
        </div>
       
        <div class="gray9" v-if="form.is_coexist == 1">同时满足以下勾选的条件，会员自动升级到该等级</div>
        <div class="gray9" v-if="form.is_coexist == 0">满足以下勾选的其中一个条件，会员自动升级到该等级</div>
        
        
        <div class="d-s-c mt16">
          <el-checkbox v-model="form.open_money">累计消费满</el-checkbox>
          <el-input v-model="form.upgrade_money" type="number" :disabled="form.open_money==0" style="width: 160px; margin-left: 10px;" ></el-input>
          <span class="ml10">元</span>
        </div>
        <!-- <div class="d-s-c mt16">
          <el-checkbox v-model="form.open_points">累计积分满</el-checkbox>
          <el-input v-model="form.upgrade_points" type="number" :disabled="form.open_points==0" style="width: 160px;margin-left: 10px;"></el-input>
          <span class="ml10">个</span>
        </div> -->
        <div class="d-s-c mt16">
          <el-checkbox v-model="form.open_invite">推荐人数满</el-checkbox>
          <el-input v-model="form.upgrade_invite" type="number" :disabled="form.open_invite==0" style="width: 160px;margin-left: 10px;"></el-input>
          <span class="ml10">人</span>
        </div>
        <!-- 20201020 累计付款 -->
        <div class="d-s-c mt16">
          <el-checkbox v-model="form.open_pay">累计付款满</el-checkbox>
          <el-input v-model="form.upgrade_pay" type="number" :disabled="form.open_pay==0" style="width: 160px;margin-left: 10px;"></el-input>
          <span class="ml10">元</span>
        </div>
        <!--20201026 累计业绩  -->
        <!-- <div class="d-s-c mt16">
          <el-checkbox v-model="form.open_achievement">累计业绩满</el-checkbox>
          <el-input v-model="form.upgrade_achievement" type="number" :disabled="form.open_achievement==0" style="width: 160px;margin-left: 10px;"></el-input>
          <span class="ml10">元且推荐人数满</span>
          <el-input v-model="form.referee_num" type="number"  min="0"  :disabled="form.open_achievement==0" style="width: 160px;margin-left: 10px;"></el-input>
          <span class="ml10">人</span>
        </div> -->

     <!--20250606 团队业绩  -->
        <div class="d-s-c mt16">
          <el-checkbox v-model="form.open_team_achievement">团队(自己+关系链下游)业绩满</el-checkbox>
          <el-input v-model="form.upgrade_team_achievement" type="number" :disabled="form.open_team_achievement==0" style="width: 160px;margin-left: 10px;"></el-input>
          <span class="ml10">元</span>
        </div>



      <!-- 商城购买任意一单 -->
      <div class="d-s-c mt16">
          <el-checkbox v-model="form.any_order">商城购买任意一单</el-checkbox> 
        </div>
 
 <!--
         
        <div class="d-s-c mt16">
            <el-checkbox v-model="form.open_grade_invite">推荐指定等级</el-checkbox>


            <el-table size="small" :data="gradeList" border>
              <el-table-column prop="name" label="等级"></el-table-column>

              <el-table-column prop="second_rebate" label=" 人数满多少人">
                <template slot-scope="scope">

                  <el-input v-model="scope.row.grade_invite_num" type="number"
                            :disabled="form.open_grade_invite==0" style="width: 160px;margin-left: 10px;"></el-input>


                </template>
              </el-table-column>

            </el-table>
          </div> -->

        <!-- 团队邀请人数 -->
        <!--  <div class="d-s-c mt16">
          <el-checkbox v-model="form.is_invite_team_num">团队人数满（包含自己）</el-checkbox>
          <el-input v-model="form.invite_team_num" type="number" :disabled="form.is_invite_team_num==0" style="width: 160px;margin-left: 10px;"></el-input>
          <span class="ml10">人</span>
        </div> -->

        <!--20201122 购买商品  -->
        <div class="d-s-c mt16">
            <el-checkbox v-model="form.open_goods">购买商品</el-checkbox>

            <div class="gray9" style="margin-left:10px;">满足其中一个商品数量升级</div>
          </div>
          <div class="d-s-c" v-if="form.open_goods == 1">
            <!-- 关联商品 -->
            <RelationProduct :form="form" :type="type"></RelationProduct>
          </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="editGrade" :disabled="submit_loading">确 定</el-button>
    </div>

    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>
    <Upload v-if="isupload2" :isupload="isupload2" :type="type" @returnImgs="returnImgsFunc2">上传图片</Upload>
    <Upload v-if="isupload3" :isupload="isupload3" :type="type" @returnImgs="returnImgsFunc3">上传图片</Upload>
    <Upload v-if="isupload4" :isupload="isupload4" :type="type" @returnImgs="returnImgsFunc4">上传图片</Upload>

  </el-dialog>
   <Product :isproduct="isproduct" @closeDialog="closeDialogFunc($event)">产品列表弹出层</Product>
  </div>
  
</template>

<script>
 import Product from '@/components/product/Product';
  import UserApi from '@/api/user.js';
  import Upload from '@/components/file/Upload';
  import RelationProduct from './Relationproduct';
  export default {
     components: {
      Upload,
      RelationProduct,
      /*产品列表组件*/
      Product:Product,
     
    },
    data() {
      return {
        // 级别
          levelList: [{
            level: 0,
          },
          {
            level: 1,
          },
          {
            level: 2,
          },
          {
            level: 3,
          },
          {
            level: 4,
          },
          {
            level: 5,
          },
          {
            level: 6,
          },
          {
            level: 7,
          },
          {
            level: 8,
          },
          {
            level: 9,
          },
        ],
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,
        /*是否正在提交*/
        submit_loading: false,
        /*是否上传图片*/
        isupload: false,
        isupload2:false,
        isupload3:false,
        isupload4:false,
        path_before:'',//点击前背景图
        path_after:'',//点击后背景图
        path:"",//icon
        detail:'',//详情图
        content:'',//备注
        isproduct:false,
        product:[],
        type:"edit",
      };
    },
    props: ['open_edit', 'form', 'gradeList'],
    created() {
      this.form.open_money=this.form.open_money==1?true:false;
      this.form.open_points=this.form.open_points==1?true:false;
      this.form.open_invite=this.form.open_invite==1?true:false;
      this.form.open_pay=this.form.open_pay==1?true:false;
      this.is_apply_store=this.form.is_apply_store==1?true:false;
      this.form.open_achievement=this.form.open_achievement==1?true:false;
         this.form.open_team_achievement=this.form.open_team_achievement==1?true:false;
      this.form.open_grade_invite = this.form.open_grade_invite==1?true:false;
      this.form.any_order = this.form.any_order==1?true:false;
      this.form.is_coexist = this.form.is_coexist==1?true:false;
      this.form.is_invite_team_num = this.form.is_invite_team_num==1?true:false;
       this.form.open_goods=this.form.open_goods==1?true:false;
      this.form.upgrade_goods_id = this.form.upgrade_goods_id?this.form.upgrade_goods_id:[];
      this.form.product = this.form.product?this.form.product:[]
      this.dialogVisible = this.open_edit;
      this.path_before = this.form.path_before;
      this.path = this.form.path;
      this.path_after = this.form.path_after;
      this.detail = this.form.detail;
      this.content = this.form.content;
      this.gradeList = this.form.gradeList;
    },
    methods: {
      /*修改用户*/
      editGrade() {
        let self = this;
        let params = this.form;

        self.$refs.form.validate((valid) => {
          if (valid) {
            self.submit_loading = true;
            if(params.is_default==0){
              params.open_money=params.open_money==true?1:0;
              params.open_points=params.open_points==true?1:0;
              params.open_invite=params.open_invite==true?1:0;
              params.open_pay=params.open_pay==true?1:0;
              params.is_apply_store = params.is_apply_store==true?1:0;
              params.open_achievement = params.open_achievement==true?1:0;
              params.open_team_achievement= params.open_team_achievement==true?1:0;
              params.detail = self.detail;
              params.path_before = self.path_before;
              params.path = self.path;
              params.path_after = self.path_after;
              params.content = self.content
              params.open_goods = params.open_goods==true?1:0;
              params.open_grade_invite =params.open_grade_invite==true?1:0;
              params.any_order = params.any_order==true?1:0;
              params.is_coexist = params.is_coexist==true?1:0;
              params.is_invite_team_num = params.is_invite_team_num==true?1:0;
            }else{
              delete params.open_money;
              delete params.open_points;
              delete params.open_invite;
              delete params.open_pay;
              delete params.open_achievement;
              delete params.open_team_achievement;
              delete params.upgrade_money;
              delete params.upgrade_points;
              delete params.upgrade_invite;
              delete params.upgrade_pay;
              delete params.upgrade_achievement
              // delete params.detail
              // delete params.path
              // delete params.content
              delete params.open_goods;
              delete params.upgrade_goods_id;
              delete params.open_grade_invite;
              delete params.any_order;
              delete params.is_coexis;
              delete params.is_invite_team_num;
            }
            // console.log(self.content);
            params.gradeList =JSON.stringify(this.gradeList);
            UserApi.editGrade(params, true)
              .then(data => {
                self.submit_loading = false;
                self.$message({
                  message: '恭喜你，等级修改成功',
                  type: 'success'
                });
                self.dialogFormVisible(true);

              })
              .catch(error => {
                self.submit_loading = false;
              });

          }
        });
      },
      /*上传*/
      openUpload(e) {
        this.type = e;
        this.isupload = true;
      },
      /*获取图片*/
      returnImgsFunc(e) {
        if (e != null && e.length > 0) {
          this.path_before = e[0].file_path;
        }
        this.isupload = false;
      },
      /*上传*/
      openUpload2(e) {
        this.type = e;
        this.isupload2 = true;
      },
      /*获取图片*/
      returnImgsFunc2(e) {
        if (e != null && e.length > 0) {
          this.detail = e[0].file_path;
        }
        this.isupload2 = false;
      },
      /*上传*/
      openUpload3(e) {
        this.type = e;
        this.isupload3 = true;
      },
      openUpload4(e){
        this.type = e;
        this.isupload4 = true;
      },
      /*获取图片*/
      returnImgsFunc3(e) {
        if (e != null && e.length > 0) {
          this.path_after = e[0].file_path;
        }
        this.isupload3 = false;
      },
      returnImgsFunc4(e) {
        console.log( e[0].file_path)
        if (e != null && e.length > 0) {
          this.path = e[0].file_path;
        }
        this.isupload4 = false;
      },
      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },
      
       /*产品列表弹出层*/
      openProduct() {
        this.isproduct = true;
      },
        /*关闭弹窗*/
        closeDialogFunc(e) {
        this.isproduct = e.openDialog;
        console.log("success",e);
        if (e.type == 'success') {
          if (this.form.upgrade_goods_id.indexOf(e.params.product_sku_id) == -1) {
            this.form.upgrade_goods_id.push(e.params.product_sku_id);
            this.form.product.push({ 
              product_sku_id:e.params.product_sku_id,
               product_id: e.params.product_id,
                product_image: e.params.product_image,
                product_name: e.params.product_name 
            });
          } else {
            this.$message({
              message: '已选择该商品',
              type: 'warning'
            });
          }
        
          
        }
      },
      /*删除商品*/
      deleteFunc(i) {
        console.log(i,this.form);
        this.form.upgrade_goods_id.splice(i, 1);
        this.form.product.splice(i, 1);
       
      },

    }
  };
</script>

<style scoped="scoped">
  .img {
    margin-top: 10px;
  }
.img {
  width: 100px;
  margin-top: 10px;
  height: 130px;
  margin-right: 10px;
}

.img img {
  border: 1px solid #eeeeee;
}

.delete-btn {
  position: absolute;
  display: block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  right: -8px;
  top: -8px;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/views/user/grade/Edit.vue